
































import {Component, Prop, Vue} from "vue-property-decorator";
import ArrowIcon from '../../../../assets/svg/web-conferences/arrow-up.svg';
import ButtonWithContext from "@share/web-conferences/components/common/ButtonWithContext.vue";
import ItemsList from "@share/web-conferences/components/common/ItemsList.vue";
import {SharingTypes} from "@api/enums/WebConferenceSlides/SharingTypes";
import PdfIcon from "@share/web-conferences/components/control-panel/share-icons/PdfIcon.vue";
import ScreenSharingIcon from "@share/web-conferences/components/control-panel/share-icons/ScreenSharingIcon.vue";
import {UserProfile} from "@api/models/UserProfile";
import RingLoader from "@share/common/RingLoader.vue";
import { ShareControllerInterface } from "@share/live-kit/interfaces/ShareControllerInterface";

@Component({
  name: "ControlPanelShare",
  components: {RingLoader, ItemsList, ButtonWithContext, ArrowIcon, PdfIcon, ScreenSharingIcon }
})
export default class ControlPanelShare extends Vue {
    @Prop({default: false}) isActive: boolean;
    @Prop({default: false}) disabled: boolean;
    @Prop( { required: true }) controller: ShareControllerInterface;
    @Prop({default: true}) canSharePdf: boolean;
    @Prop({default: false}) buttonMode: boolean;

    isSharingSwitching = false;
    isSharingBeginStopped = false;
    options = [
        {
            key: SharingTypes.Slides,
            iconComponent: 'PdfIcon'
        },
        {
            key: SharingTypes.Screen,
            iconComponent: 'ScreenSharingIcon'
        }
    ];

    get label() {
        return this.$t('web-conferences.share');
    }

    get filteredOptions() {
        return this.options.filter(item => {
            return this.canSharePdf ? true : item.key != SharingTypes.Slides;
        });
    }

    get currentUserProfile(): UserProfile {
        return this.$store.getters.profile;
    }

    get isThereSharingTracks() {
        return this.controller.isThereSharingTracks;
    }

    get isCurrentPresentationActive() {
        return this.controller.isCurrentPresentationActive;
    }

    mounted() {
        if (
            this.controller.webConferenceData?.hasSharingType(SharingTypes.Screen) &&
            this.controller.webConferenceData?.isSharingUser(this.currentUserProfile.userId as number)
        ) {
            this.controller.shareScreen();
        }
    }

    async onLabelClick() {
        if (this.controller.isSharing) {
          await this.controller.stopSharing();
        }
    }

    // @Watch('isThereSharingTracks')
    // onSharingTracksChanged() {
    //     console.log('sharing changed', this.controller.webConferenceData?.hasSharingType(SharingTypes.Screen),this.controller.isSharing, !this.isThereSharingTracks)
    //     if (this.controller.webConferenceData?.hasSharingType(SharingTypes.Screen) &&
    //         this.controller.isSharing && !this.isThereSharingTracks)
    //     {
    //         this.controller.stopSharing();
    //     }
    // }
    //
    // @Watch('isCurrentPresentationActive')
    // onIsCurrentPresentationActiveChanged() {
    //     if (!this.isCurrentPresentationActive && this.controller.isSharingScreen) {
    //         this.controller.stopSharing();
    //     }
    // }
}
